import React from "react";
import { withRouter } from "react-router-dom";
import { InputElement, DropdownListElement } from "../../shared/FormElements";
import { SiteConstants } from "../../../constants/constant";

const Personal = props => {
  const handleEnterKey = event => {
    const eventCode = event.which || event.keyCode;
    if (eventCode === SiteConstants.ENTER_KEY_EVENT_CODE) {
      props.sucessHandler(props.formName);
    }
  };
  const personalStructure = props.form.map((value, index) => {
    let dropDownValue =
      props.preferencesDropdown && props.preferencesDropdown.subscriberRoles;
    if (value.config.name == "Domain") {
      dropDownValue =
        props.preferencesDropdown &&
        props.preferencesDropdown.subscriberInvestmentDomains;
    }
    if (value.config.type == "select") {
      return (
        <div
          key={value + index}
          className="d-flex justify-content-center  no-gutter"
        >
          <DropdownListElement
            name={value.id}
            type={value.config.type}
            class="mb-3 col-12 form-group mt-20"
            label={value.config.label}
            checkButton={value.config.checkButton}
            checkForm={value.config.checkForm}
            required={value.config.validation.require}
            value={value.config.value}
            options={dropDownValue}
            onChangeHandler={props.onChangeHandler}
            formName={props.formName}
            onBlurHandler={props.onBlurHandler}
            errorMsg={value.config.errorMsg}
            valid={value.config.valid}
            maxLength={value.config.maxLength}
          />
        </div>
      );
    }
    return (
      <div
        key={value + index}
        className="d-flex justify-content-center  no-gutter"
      >
        {
          value.config.value.includes("privaterelay.appleid.com") ? null :
              <InputElement
                  name={value.id}
                  type={value.config.type}
                  class={
                    value.config.class ? value.config.class : "mb-3 col-12 form-group mt-20"
                  }
                  checkButton={value.config.checkButton}
                  checkForm={value.config.checkForm}
                  label={value.config.label}
                  required={value.config.validation.require}
                  value={value.config.value}
                  readOnly={
                    (props.userProfile && props.userProfile.toLowerCase() == "linkedin") || (props.userProfile && props.userProfile.toLowerCase() == "apple")
                        ? value.config.readonly
                        : value.config.checkReadOnly
                        ? false
                        : value.config.readonly
                  }
                  validationTick={
                    value.config.validationTick && value.config.validationTick
                  }
                  typing={value.config.typing && value.config.typing}
                  onChangeHandler={props.onChangeHandler}
                  formName={props.formName}
                  onBlurHandler={props.onBlurHandler}
                  errorMsg={value.config.errorMsg}
                  valid={value.config.valid}
                  maxLength={value.config.maxLength}
                  placeholder={value.config.placeholder ? value.config.placeholder : ""}
                  belowPlaceholder={
                    value.config.belowPlaceholder ? value.config.belowPlaceholder : ""
                  }
              />
        }
      </div>
    );
  });
  return (
    <div>
      {props.message && <p className="error">{props.message}</p>}
      <h3 className="heading">Personal information</h3>
      <p className="subheading">Manage your personal information</p>
      <div className="fromSpacing">
        {props.userProfile && props.userProfile.toLowerCase() == "linkedin" && (
          <p className="linkedinInfo">
            <img src="/assets/svg/linkedinBtn.svg" alt="linkedin" />
            You are signed into ausbiz via LinkedIn - some details cannot be
            modified.
          </p>
        )}
        {props.userProfile && props.userProfile.toLowerCase() == "apple" && (
            <p className="appleInfo">
              <img src = "../../../assets/svg/apple-logo.svg"/>
              You are signed into ausbiz via Apple - some details cannot be
              modified.
            </p>
        )}
        {personalStructure}
      </div>
      <button
        type="submit"
        className={props.btnDisabled ? "btn continue" : "btn continue active"}
        disabled={props.btnDisabled ? "disabled" : ""}
        onClick={() => props.sucessHandler(props.formName)}
        onKeyPress={event => handleEnterKey(event)}
      >
        Update
      </button>
    </div>
  );
};

export default withRouter(Personal);
